import * as THREE from 'three';
import ObjectArrayView from '../../generic/container/ObjectArrayView';
import ObjectBuffer from '../../generic/container/ObjectBuffer';
import PolyMesh from '../model/PolyMesh';
import PolyMap from '../model/PolyMap';

export default function removeDuplicateNormals(polyMesh, removeUnusedValues, withLogging) {

  if (!polyMesh.normalMap) return polyMesh;

  const ru = removeUnusedValues || true;
  const l = withLogging || false;

  const faceValueIndices = polyMesh.positions.faceValueIndices;
  const values = polyMesh.positions.values;

  const normalFaceValueIndices = new Uint32Array(polyMesh.normalMap.faceValueIndices);
  const normalValues = polyMesh.normalMap.values;

  let duplicatesFound = 0;

  let n1, n2;

  //TODO bad nested array
  const valuesToIndices = [];
  for (let i = 0; i < values.length; i++) {
    valuesToIndices[i] = [];
  }

  for (let i = 0; i < faceValueIndices.length; i++) {
    valuesToIndices[faceValueIndices[i]].push(i);
  }

  //compares every normal on specific vertices to each other
  //then remaps indices of normals that are the same
  for (let i = 0; i < valuesToIndices.length; i++) {

    for (let j = 0; j < valuesToIndices[i].length; j++) {

      n1 = normalFaceValueIndices[valuesToIndices[i][j]];
      for (let k = 0; k < valuesToIndices[i].length; k++) {

        n2 = normalFaceValueIndices[valuesToIndices[i][j + k]];
        if (n1 !== n2 && normalValues.getAt(n1).dot(normalValues.getAt(n2)) > 0.99) {
          normalFaceValueIndices[valuesToIndices[i][j + k]] = n1;
          duplicatesFound++;
        }

      }
    }
  }

  if (l) console.log('Normal Duplicates Found: ' + duplicatesFound);

  let normals = normalValues;
  if (ru && duplicatesFound) {
    let newNormalValuesBuffer = new ObjectBuffer(THREE.Vector3);
    let isUsed = new Int32Array(normalValues.length);
    isUsed.fill(-1);

    let newNormalsCount = 0;
    for (let i = 0; i < normalFaceValueIndices.length; i++) {
      if (isUsed[normalFaceValueIndices[i]] === -1) {
        newNormalValuesBuffer.push(normalValues.getAt(normalFaceValueIndices[i]));
        isUsed[normalFaceValueIndices[i]] = newNormalsCount++;
      }

      normalFaceValueIndices[i] = isUsed[normalFaceValueIndices[i]];
    }

    let newNormalValues = new ObjectArrayView(THREE.Vector3, newNormalsCount);
    newNormalValues.fromArray(newNormalValuesBuffer.toArray());

    normals = newNormalValues;
    if (l) console.log('' + normalValues.length + ' normal values reduced to ' + newNormalValues.length + ', duplicates removed: ' + (normalValues.length - newNormalValues.length));
  }

  const newNormals = new PolyMap({
    faceRangeOffsets: polyMesh.faceRangeOffsets,
    faceValueIndices: normalFaceValueIndices,
    values: normals,
  });

  let resultMesh = new PolyMesh(polyMesh);
  resultMesh.normalMap = newNormals;
  return resultMesh;
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/removeDuplicateNormals.js